import request from '@/utils/request'

/* member user */
export function getUserList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetUserList.json',
    method: 'post',
    params
  })
}

export function addUser(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddMemberUser.json',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateMemberUser.json',
    method: 'post',
    data
  })
}

export function updateUserPassword(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateUserPassword.json',
    method: 'post',
    data
  })
}

export function adminDeleteUser(id) {
  const data = {
    userId: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteUser.json',
    method: 'post',
    data
  })
}

export function addPlayerTeamExperience(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddPlayerTeamExperience.json',
    method: 'post',
    data
  })
}

export function deletePlayerTeamExperience(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/DeletePlayerTeamExperience.json',
    method: 'post',
    data
  })
}

export function getPlayerTeamExperienceList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerTeamExperienceList.json',
    method: 'get',
    params
  })
}

export function getPlayerTeamList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetPlayerTeamList.json',
    method: 'get',
    params
  })
}

export function getUserById(id) {
  const params = {
    id: id
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetUser.json',
    method: 'get',
    params
  })
}

export function addMembershipTypeToMemberUser(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AddMembershipTypeToMemberUser.json',
    method: 'post',
    data
  })
}

/* 更改会员状态 */
export function updateMembershipStatus(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateMembershipStaus.json',
    method: 'post',
    data
  })
}

export function updatePaymentStatus(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateMembershipPaymentStatus.json',
    method: 'post',
    data
  })
}

/* history info */
// 1运动员 2教练
export function getHistoryOrganization(id, memberType) {
  const params = {
    userId: id,
    membershipType: memberType
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetHistoryOrganization.json',
    method: 'get',
    params
  })
}

// 0会员单位 1运动员 2教练 3裁判
export function getHistoryMembershipYear(id, memberType) {
  const params = {
    userId: id,
    membershipType: memberType
  }
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetHistoryMembershipYear.json',
    method: 'get',
    params
  })
}

//
export function getOrganizationList(params) {
  params = params || {}
  params.pageSize = 99999
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetOrganizationList.json',
    method: 'get',
    params
  })
}

export function getCoachList(params) {
  params = params || {}
  params.pageSize = 99999
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetCoachList.json',
    method: 'get',
    params
  })
}

export function getInsureOrder(params) {
  params = params || {}
  return request({
    url: process.env.BJH_API + '/api/content/pc/GetInsureOrder.json',
    method: 'get',
    params
  })
}

export function AdminRefundMembershipInsurance(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminRefundMembershipInsurance.json',
    method: 'post',
    data
  })
}

export function getAuditList() {
  return [
    { value: '', label: '全部' },
    { value: 3, label: '待注册' },
    { value: 0, label: '待审核' },
    { value: 1, label: '未通过' },
    { value: 2, label: '已通过' },
    { value: -1, label: '异常冻结' }
  ]
}

export function getPaymentList() {
  return [
    { value: '', label: '全部' },
    { value: 0, label: '待支付' },
    { value: 1, label: '已支付' },
    { value: 2, label: '手动支付' }
  ]
}

export function getInsurePaymentList() {
  return [
    { value: '', label: '全部' },
    { value: 0, label: '待支付' },
    { value: 1, label: '已支付' }
  ]
}

export function getPlayerAuditList() {
  return [
    { value: '', label: '全部' },
    { value: 0, label: '待确认' },
    { value: 1, label: '未通过' },
    { value: 2, label: '通过' }
  ]
}
